import React from 'react';
import HeroSection from '../components/common/HeroSection';
import WhoIsChaitraleeContent from '../components/chaitralee/WhoIsChaitralee';

const breadcrumb = [
  { key: 'nav.home',             path: '/' },
  { key: 'nav.whoIsChaitralee',  path: null },
];

const WhoIsChaitralee = () => (
  <>
    <HeroSection
      titleKey="who.title"
      subtitleKey="who.subtitle"
      breadcrumbItems={breadcrumb}
    />
    <WhoIsChaitraleeContent />
  </>
);

export default WhoIsChaitralee;
